module.exports = __webpack_public_path__ + "static/media/map_wrapper.006cfb9a.png";